module.exports = function getResource(label, vars = []) {
    let resources = {
        showCard: 'Show Card',
        point: 'Point',
        points: 'Points'
    };

    return resources[label];
};
